import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
function SearchOptionItem({ query, render, dataItem }) {
    const node = useRef()
    useEffect(() => {})

    return (
        <Link className={'r-search-option-container'} to={dataItem.url}>
            {render(dataItem)}
        </Link>
    )
}

export default SearchOptionItem
